import {BackendApiManager} from '../../managers/backend-api';

/**
 * Downloads a file from the given URL and triggers a download in the browser.
 */
export async function downloadFile(fileUrl: string, fileName?: string) {
  // Get file content from the backend
  const response = await BackendApiManager.instance.get(fileUrl, {
    responseType: 'blob',
  });
  const downloadUrl = window.URL.createObjectURL(response.data as Blob);

  // Prepare download
  const downloadLink = document.createElement('a');
  downloadLink.href = downloadUrl;
  downloadLink.setAttribute('download', fileName || 'download');
  document.body.appendChild(downloadLink);

  // Trigger download
  downloadLink.click();

  // Clean up
  document.body.removeChild(downloadLink);
  window.URL.revokeObjectURL(downloadUrl);
}
